import React, {Component} from 'react';
import {
    TouchableWithoutFeedback
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

export class RestaurantItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            item: props.item,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render() {
        return (
            <div className="restaurant-card d-flex flex-fill" style={{ flexDirection: 'column' }}>
                <TouchableWithoutFeedback
                    to={'/public/menu/' + this.state.item.reS_MENU_ID}
                    style={{ flexGrow: 1 }}
                >
                    {this.state.item.reS_IMAGE ?
                        <img src={this.state.item.reS_IMAGE} />
                        :
                        null
                    }
                    <div className="restaurant-card-body">
                        <h4>
                            {this.state.item.reS_NAME}
                        </h4>
                        <p style={{ marginTop: 7 }}>
                            {this.state.item.reS_DESCRIPTION}
                        </p>
                    </div>
                </TouchableWithoutFeedback>
                <div className={'card-footer'}>
                    <a
                        target="_blank"
                        href={"http://maps.google.com/?q=" + this.state.item.reS_LOCATION + "," + this.state.item.reS_CITY + "," + this.state.item.stateName}
                    >
                        <div>
                            {this.state.item.reS_LOCATION}, {this.state.item.reS_CITY}, {this.state.item.stateName}
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}
